import { useTranslation } from '@flecto/translations'
import { type CoreCustomerDocType, type CoreCustomer } from '@flecto/types'

import { Badge } from '..'

type BadgeCustomerVerificationProps = {
  customer?: Partial<CoreCustomer>
}

export function BadgeCustomerVerification({
  customer,
}: BadgeCustomerVerificationProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'customers' })

  if (!customer || customer?.internal) {
    return null
  }

  const mapDocumentType = (docType: CoreCustomerDocType): string => {
    switch (docType) {
      case 'civil':
        return t('document_type.civil')
      case 'passport':
        return t('document_type.passport')
      case 'drivers_license':
        return t('document_type.drivers_license')
      case 'other':
        return t('document_type.other')
      default:
        return t('document_type.unknown')
    }
  }

  const documentTypeLabel = customer.id_document_type
    ? mapDocumentType(customer.id_document_type)
    : null

  if (!customer.id_document_number) {
    return (
      <Badge
        color='gray'
        data-testid='document-verification-badge-without-document'
      >
        {t('customer_without_document')}
      </Badge>
    )
  }

  const verifiedAt = Boolean(customer.id_verified_at)
  const color = verifiedAt ? 'green' : 'red'

  return (
    <Badge color={color} data-testid='document-verification-badge' withDot>
      <span data-testid='document-verification-badge-text'>{`${documentTypeLabel} #${customer.id_document_number}`}</span>
    </Badge>
  )
}
